import { STATUS_FAIL } from '@/mixins/onlineCheckMixin';

/**
 * @description Примесь пополнения аванса.
 * @type {object}
 */
export default {
  data() {
    return {
      /**
       * @description Показывать форму пополнения аванса.
       * @type {boolean}
       */
      isShownAdvanceRechargeForm: false,
      /**
       * @description Ожидание завершения запроса пополнения аванса.
       * @type {boolean}
       */
      isAwaitAdvanceRechargeRequest: false,
      /**
       * @description Идентификатор команды пополнения.
       * @type {(number|null)}
       */
      rechargeCommandId: null,
    };
  },
  methods: {
    /**
     * @description Ожидание распечатки чека.
     * @type {number} commandId Идентификатор команды.
     * @returns {Promise<boolean>}
     */
    waitAdvanceRechargeCheckPrinted(commandId) {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        return false;
      };
      const onSuccess = (result) => {
        if (result.status === STATUS_FAIL) {
          this.notifyFail(result.message);
          return false;
        }
        this.onCloseAdvanceRechargeForm();
        this.notifySuccess('Чек получен');
        return true;
      };
      return this
        .waitExecuted(commandId)
        .then(onSuccess, onFail)
        .finally(() => {
          this.isAwaitCommandExecuted = false;
        });
    },
    /**
     * @description Открыть форму.
     * @returns {void}
     */
    openAdvanceRechargeForm() {
      this.isShownAdvanceRechargeForm = true;
    },
    /**
     * @description Обработать закрытие формы.
     * @returns {void}
     */
    onCloseAdvanceRechargeForm() {
      this.isShownAdvanceRechargeForm = false;
    },
    /**
     * @description Отправить запрос на пополнение аванса.
     * @param {AdvanceRechargeRequest} request Запрос.
     * @returns {Promise<boolean>}
     */
    sendAdvanceRechargeRequest(request) {
      this.isAwaitAdvanceRechargeRequest = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        return false;
      };
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        if (response.command_id) {
          this.rechargeCommandId = response.command_id;
          return this.waitAdvanceRechargeCheckPrinted(this.rechargeCommandId);
        }
        this.onCloseAdvanceRechargeForm();
        return true;
      };
      return this
        .$invoiceGateway
        .advanceRecharge(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitAdvanceRechargeRequest = false; });
    },
  },
};
